export default __webpack_public_path__ + "static/media/mockRare-300.5a7d54e6.png";